module.exports = __webpack_public_path__ + "static/media/home-24px.81344860.svg";